import React, { useContext } from 'react'
import get from 'lodash/get'
import { useTheme } from '@material-ui/core/styles'
import TenantThemeContext from '@signal/core/tenantTheme/Context'
import withCommonSnapshotsOnly from '@signal/hoc/withCommonSnapshotsOnly'
import { paletteTypeSelector } from '@signal/theme/selectors'
import { Image } from './styles'

const DEFAULT_LOGO_HEIGHT = 80
const DEFAULT_LOGO_WIDTH = 195

export function Brand({
  height = DEFAULT_LOGO_HEIGHT,
  width = DEFAULT_LOGO_WIDTH,
  ...rest
}) {
  const theme = useTheme()
  const paletteType = paletteTypeSelector(theme)
  const isDarkMode = paletteType === 'dark'
  const filename = isDarkMode ? 'PC-1c-reversed-horizontal' : 'PC-fc-horizontal'
  const tenantTheme = useContext(TenantThemeContext)
  const tenantLogo = get(tenantTheme, 'response.tenantLogo')
  const src =
    tenantLogo || `https://purecars-signal.imgix.net/app/${filename}.svg`
  return (
    <Image alt="Brand logo" src={src} height={height} width={width} {...rest} />
  )
}

export default withCommonSnapshotsOnly(Brand)
